import { render, staticRenderFns } from "./cardPackage.vue?vue&type=template&id=4b2b4acf&scoped=true&"
import script from "./cardPackage.vue?vue&type=script&lang=js&"
export * from "./cardPackage.vue?vue&type=script&lang=js&"
import style0 from "./cardPackage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cardPackage.vue?vue&type=style&index=1&id=4b2b4acf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b4acf",
  null
  
)

export default component.exports